const LoadingDocumentLibrary = () => {
  return (
    <div className='animate-pulse w-full bg-gray-100 flex justify-between my-2 p-4 shadow-md rounded-md border'>
      <div className='h-12 w-12 rounded-md bg-neutralColor-light mr-10'></div>
      <div className='flex flex-col gap-4 w-full'>
        <div className='flex gap-8 items-center w-2/3 rounded-md h-4 bg-neutralColor-light'></div>
        <div className='flex gap-8 items-center w-1/2 rounded-md h-4 bg-neutralColor-light'></div>
      </div>
      <div className='flex gap-2'>
        <div className='bg-neutralColor-light p-1 rounded-full hover:bg-neutralColor-light h-10 w-10 flex items-center justify-center cursor-pointer'></div>
        <div className='bg-neutralColor-light p-1 rounded-full hover:bg-neutralColor-light h-10 w-10 flex items-center justify-center cursor-pointer'></div>
      </div>
    </div>
  );
};

export default LoadingDocumentLibrary;
